import { IAddress } from './address';

export enum FacilityType {
  WAREHOUSE = 'WAREHOUSE',
  STORE = 'STORE',
  VENDOR = 'VENDOR',
}

// Wire values and labels agreed with SCM (FacilityStaffRole). Readers show unknown roles as "Staff".
export const FACILITY_STAFF_ROLE_OPTIONS = [
  { value: 'STORE_MANAGER', label: 'Store manager' },
  { value: 'ASSISTANT_STORE_MANAGER', label: 'Assistant store manager' },
  { value: 'BACK_OFFICE_MANAGER', label: 'Back office manager' },
  { value: 'BACK_OFFICE_EXECUTIVE', label: 'Back office executive' },
  { value: 'WAREHOUSE_MANAGER', label: 'Warehouse manager' },
  { value: 'WAREHOUSE_EXECUTIVE', label: 'Warehouse executive' },
  { value: 'OTHER', label: 'Staff' },
] as const;

export type FacilityStaffRole = (typeof FACILITY_STAFF_ROLE_OPTIONS)[number]['value'];

export interface IFacilityStaffContact {
  name: string;
  role: FacilityStaffRole;
  phone: string;
}

export interface IFacility {
  id: number;
  name: string;
  address: IAddress;
  facilityType: FacilityType;
  vendorId: number;
  enabled: boolean;
  grnEnabled: boolean;
  jitEnabled?: boolean;
  unicomFacilityCode: string;
  jitInvSyncEnabled: boolean;
  billToFacilityId: number;
  defaultPOFacilityId: number;
  gstin: string;
  storeSizeInSqFt: number;

  cloudflareVideoId?: string;

  addressLine1?: string;
  addressLine2?: string;
  contactPhone?: string;
  displayLocation?: string;
  mapUrl?: string;
  timings?: string;
  imageUrl?: string;
  onlineSaleable?: boolean;
  expressDeliveryZone?: string;
  expressServiceabilityEnabled?: boolean;
  jitB2b2cExpressEnabled?: boolean;
  unicomMarketplaceOrderSyncEnabled?: boolean;
  /** Unicom-backed picking (SCM `facility.unicom_picking_enabled`); off means LOCAL shelf-suggestion picking. */
  unicomPickingEnabled?: boolean;
  expressPriorityRank?: number;
  config?: Record<string, unknown>;
  whatsappGroupChatId?: string;
  // Ordered list (rider call order). Served only by the ERP admin facility GET.
  staffContacts?: Array<IFacilityStaffContact>;
}
